import { render } from "./B2bLoginFooter.vue?vue&type=template&id=110598e6&scoped=true&lang=pug"
import script from "./B2bLoginFooter.vue?vue&type=script&lang=js"
export * from "./B2bLoginFooter.vue?vue&type=script&lang=js"

import "./B2bLoginFooter.vue?vue&type=style&index=0&id=110598e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110598e6"]])

export default __exports__